import React, { useState } from "react";
import "./industriesDms.css";

import {FiArrowRight} from "react-icons/fi";
import {
  FaCartShopping,
  FaUtensils,
  FaCapsules,
  FaIndustry,
  FaBoxesStacked,
  FaTruck,
  FaStore,
  FaBasketShopping,
  FaFlask,
  FaBolt,
  FaCar,
} from "react-icons/fa6";
import DmsBookingModal from "./dmsBookingModal";

const industries = [
  {
    icon: FaCartShopping,
    title: "FMCG",
    text: "Manage fast-moving consumer products, distributor orders, retailer coverage, inventory and secondary sales across a wide and continuously expanding outlet network.",
  },
  {
    icon: FaUtensils,
    title: "Food & Beverage",
    text: "Manage food and beverage products, batches, expiry information, distributor inventory and sales movement across your entire distribution channel.",
  },
  {
    icon: FaCapsules,
    title: "Pharma",
    text: "Manage pharmaceutical distribution with visibility into products, batches, expiry dates, distributors, orders and inventory movement across the channel.",
  },
  {
    icon: FaIndustry,
    title: "Manufacturing",
    text: "Connect manufacturing, warehouse, inventory, primary sales and distribution operations to maintain product availability and improve channel visibility.",
  },
  {
    icon: FaBoxesStacked,
    title: "Wholesale",
    text: "Simplify bulk order processing, dealer management, inventory visibility, pricing and customer operations across your wholesale distribution network.",
  },
  {
    icon: FaTruck,
    title: "Distribution",
    text: "Manage distributors, dealers, territories, orders, inventory, collections and channel performance through one connected distribution platform.",
  },
  {
    icon: FaStore,
    title: "Retail",
    text: "Improve retailer coverage, order visibility, sales activity and product availability by connecting retail operations with your wider distribution network.",
  },
  {
    icon: FaBasketShopping,
    title: "Consumer Goods",
    text: "Connect warehouses, distributors and retailers while gaining visibility into product movement, orders, inventory and channel performance.",
  },
  {
    icon: FaFlask,
    title: "Chemicals",
    text: "Manage chemical products, batches and inventory while maintaining visibility across distributors, orders and product movement throughout the distribution network.",
  },
  {
    icon: FaBolt,
    title: "Electrical",
    text: "Manage electrical products, dealers and distributors with centralized orders, inventory visibility, customer information and channel-level reporting.",
  },
  {
    icon: FaCar,
    title: "Automotive",
    text: "Manage automotive products and parts, dealer relationships, inventory, orders and distribution activity across an extended automotive network.",
  },
];

const IndustriesDms = () => {
  const [showDmsModal, setShowDmsModal] = useState(false);

  return (
    <>
      <section className="industries-dms-section">
        <div className="industries-dms-glow industries-dms-glow-one"></div>
        <div className="industries-dms-glow industries-dms-glow-two"></div>

        <div className="container">
          <div
            className="industries-dms-heading"
            data-aos="fade-up"
            data-aos-duration="850"
          >
            <span className="industries-dms-label">INDUSTRIES SERVED</span>

            <h2>
              Built for Every
              <br />
              <span>Distribution-Led Industry</span>
            </h2>

            <p>
              Techcognics DMS supports businesses where products, distributors,
              dealers, sales teams and retailers need to stay connected.
            </p>
          </div>

          <div className="industries-dms-grid">
            {industries.map((industry, index) => {
              const Icon = industry.icon;

              return (
                <div
                  className="industry-dms-card"
                  key={industry.title}
                  data-aos="fade-up"
                  data-aos-duration="700"
                  data-aos-delay={index * 60}
                >
                  <div className="industry-dms-card-top">
                    <div className="industry-dms-icon">
                      <Icon />
                    </div>

                    <span className="industry-dms-number">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                  </div>

                  <h3>{industry.title}</h3>

                  <p>{industry.text}</p>

                  <span className="industry-dms-card-line"></span>
                </div>
              );
            })}
          </div>

          <div
            className="industries-dms-cta"
            data-aos="fade-up"
            data-aos-duration="800"
            data-aos-delay="300"
          >
            <button
              type="button"
              className="industries-dms-cta-btn"
              onClick={() => setShowDmsModal(true)}
            >
              Talk to a DMS Expert
              <span>
                <FiArrowRight />
              </span>
            </button>
          </div>

          <div
            className="industries-dms-bottom"
            data-aos="fade-up"
            data-aos-duration="700"
            data-aos-delay="400"
          >
            <span className="industries-dms-bottom-line"></span>

            <p>
              One platform for distribution-led businesses across industries.
            </p>

            <span className="industries-dms-bottom-line"></span>
          </div>
        </div>
      </section>
      <DmsBookingModal
        show={showDmsModal}
        onClose={() => setShowDmsModal(false)}
      />
    </>
  );
};

export default IndustriesDms;
